// tslint:disable:curly

import { Injectable } from '@angular/core';
import { ArcService } from './arc.service';
import { DbRecord } from './db-record';
import { RuntimeService } from './runtime.service';
import { UtilsService } from './utils.service';
import { Project } from './project';
import { DbRecordService } from './db-record.service';

@Injectable()
export class RatingService {
  private _userLs;
  private _abstractConflicts = new Set<string>();
  private _fulltextConflicts = new Set<string>();
  private _filterSwitch;
  private _currentProjectValues;
  private _currentProjectRTags;
  private _ratedAbstracts = new Set<string>();
  public selectedUser: string;
  private _key2label = new Map<string, string>();

  // isMeOnly = false;

  private noFulltextRating = {
    glykoalkaloids: true,
    quinoalkaloids: true,
    // hilda_alzheimer: true,
    // hilda_parkinson: true
  };


  projectsAcceptedTags = this.utils.data.projectsAcceptedTags;
  projectsValues = this.utils.data.projectsValues;


  defaultNotRatedAbstract = [
    ['notRated', 'Not Rated'],
    ['postponed', 'Postponed']
  ];

  defaultNotRatedFulltext = [
    ['notRated', 'Not Rated'],
    ['postponed', 'Postponed']
  ];

  defaultAcceptAbstract = [
    ['structure', 'Structure'],
    ['chemicalData', 'Chemical data'],
    ['physicalData', 'Physical data']
  ];

  defaultRejectAbstract = [
    ['duplicate', 'Duplicate'],
    ['irrelevant', 'Irrelevant'],
    ['mishit', 'Mishit']
  ];

  defaultAcceptFulltext = [
    ['structure', 'Structure'],
    ['chemicalData', 'Chemical data'],
    ['physicalData', 'Physical data']
  ];

  defaultRejectFulltext = [
    ['duplicate', 'Duplicate'],
    ['irrelevant', 'Irrelevant'],
    ['mishit', 'Mishit']
  ];

  constructor(
    private arcs: ArcService,
    private rs: RuntimeService,
    private utils: UtilsService,
    private dbrs: DbRecordService
  ) {
    this.rs.ratings = this;
    this.dbrs.ratingService = this;
  }


  get showFulltextRating() {
    return !this.noFulltextRating[this.rs.currentProject.shortcut];
  }

   private _parseRTag(txt, p: Project) {
    let i = txt.indexOf('|');
    let obj = { id: txt.slice(0, i), title: txt.slice(i + 1) };
    p.rTagsTitlesMap.set(obj['id'], obj['title']);
    return obj;
  }

  prepareProject(p: Project) {
    if (!p) {
      return;
    }
    let dct = this.projectsValues[p.shortcut];
    this._currentProjectValues = {
      acceptAbstract: (dct && dct['acceptAbstract']) || this.defaultAcceptAbstract,
      notRatedAbstract: (dct && dct['notRatedAbstract']) || this.defaultNotRatedAbstract,
      rejectFulltext: (dct && dct['rejectFulltext']) || this.defaultRejectAbstract,
      acceptFulltext: (dct && dct['acceptFulltext']) || this.defaultAcceptFulltext,
      notRatedFulltext: (dct && dct['notRatedFulltext']) || this.defaultNotRatedFulltext,
      rejectAbstract: (dct && dct['rejectAbstract']) || this.defaultRejectAbstract
    };
    p.abstractRejectIds = this._currentProjectValues['rejectAbstract'].map(x => x[0]);
    p.abstractAcceptIds = this._currentProjectValues['acceptAbstract'].map(x => x[0]);

    Object.keys(this._currentProjectValues).forEach(k => {
      const ls = this._currentProjectValues[k] || [];
      ls.forEach(tpl =>
        this._key2label.set(tpl[0], tpl[1]));
    });

    let rawRtags = this.projectsAcceptedTags[p.shortcut];
    if (!rawRtags) {
      return;
    }

    this._currentProjectRTags = [];
    rawRtags.forEach(tpl => {
      let ls = [];
      this._currentProjectRTags.push([this._parseRTag(tpl[0], p), ls]);
      tpl[1].forEach(x => ls.push(this._parseRTag(x, p)));
    });
    p.rtags = this._currentProjectRTags;
  }

  label(k) {
    return this._key2label.get(k) || k;
  }

  get rTagsGroups() {
    return this._currentProjectRTags;
  }

  showRTags(dbRecord) {
    return this.isAbstractRated(dbRecord);
  }

  filter(ls: DbRecord[]) {

    if (!this._filterSwitch && !this.selectedUser)
      return ls;

    let val = { a: 'accepted', r: 'rejected', c: 'conflict', n: 'notrated' }[(this._filterSwitch || '').charAt(1)];
    if (val === 'conflict') {
      let s = this._filterSwitch.startsWith('a') ? this._abstractConflicts : this._fulltextConflicts;
      return ls.filter(x => s.has(x.id));
    }

    if (val === 'notrated') {
      return ls.filter(x => !this._ratedAbstracts.has(x.id));
    }

    let mp = !this._filterSwitch || this._filterSwitch.startsWith('a') ? this.rs.currentProject.abstractRatings :
      this.rs.currentProject.fulltextRatings;
    return ls.filter(x => this._checkFilter(x, mp, val));
  }

  private _checkFilter(dbRecord: DbRecord, mp, val) {
    let x = mp.get(dbRecord.id);
    if (!x)
      return false;
    if (this.selectedUser && !x.has(this.selectedUser))
      return false;
    if (!val) {
      return true;
    }
    let returnVal = false;
    x.forEach(tpl => {
      if (!returnVal)
        returnVal = tpl[0] === val;
    });
    return returnVal;
  }

  isFilterOn(tag) {
    return this._filterSwitch === tag;
  }

  filterSwitch(tag) {
    if (this._filterSwitch === tag)
      this._filterSwitch = null;
    else
      this._filterSwitch = tag;
  }

  private _statsCounter(ratingTp, counter) {
    let mp = ratingTp === 'abstract' ? this.rs.currentProject.abstractRatings :
      this.rs.currentProject.fulltextRatings;
    let prefix = ratingTp.charAt(0);

    mp.forEach((m, recordId) => {
      let isConflict = false;
      let tp;
      let hasMyself = false;
      m.forEach((tpl, u) => {
        if (u === this.utils.email)
          hasMyself = true;
        if (tpl[0] === 'notRated')
          return;
        if (!tp)
          tp = tpl[0];
        else if (!isConflict)
          isConflict = tp !== tpl[0];

        // if (isConflict && (!this.isMeOnly || hasMyself))
        if (isConflict)
          this[`_${ratingTp}Conflicts`].add(recordId);
        /* if (this.isMeOnly && this.utils.email !== u)
          return; */

        counter[`${prefix}_${tpl[0]}`] += 1;
        this._ratedAbstracts.add(recordId);
      });
    });
    counter[`${prefix}_conflicts`] = this[`_${ratingTp}Conflicts`].size;
  }

  get stats() {
    let counter = { a_accepted: 0, a_rejected: 0, f_accepted: 0, f_rejected: 0 };
    this._ratedAbstracts = new Set<string>();
    this._statsCounter('abstract', counter);
    this._statsCounter('fulltext', counter);
    counter['a_notrated'] = this.dbrs.getTotalDbRecordsCount(this.rs.currentProject) - this._ratedAbstracts.size;
    return counter;
  }

  isAbstractRated(dbRecord: DbRecord) {
    return dbRecord.project.isAbstractRated(dbRecord);
  }

  get userLs() {
    if (this._userLs)
      return this._userLs;
    this._userLs = [];
    let obs = this.arcs.run({ fun: 'getUsers' });
    obs.subscribe((resp) => {
      this._userLs = resp;
      this._userLs.sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1);
    });
    return [];
  }


  get notRatedAbstractValues() {
    return this._currentProjectValues['notRatedAbstract'];
  }

  get acceptAbstractValues() {
    return this._currentProjectValues['acceptAbstract'];
  }

  get rejectAbstractValues() {
    return this._currentProjectValues['rejectAbstract'];
  }

  get notRatedFulltextValues() {
    return this._currentProjectValues['notRatedFulltext'];
  }

  get acceptFulltextValues() {
    return this._currentProjectValues['acceptFulltext'];
  }

  get rejectFulltextValues() {
    return this._currentProjectValues['rejectFulltext'];
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/rating.service.ts